import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { MonthlyExpenseBranchRow } from "../../types/monthly-expense.type";
import { GridNavigationProvider } from "../common/EditableGrid/GridNavigationProvider";
import { TABLE_SX, tableContainerSx } from "../DailyExpense/tableStyles";
import CloseTableFoot from "./CloseTableFoot";
import CloseTableHead from "./CloseTableHead";
import CloseTableRow, { CloseRowHandlers } from "./CloseTableRow";
import { TABLE_MAX_HEIGHT } from "./closeTableStyles";
import { ColumnGroupKey } from "./constants";
import { BranchFigures, CloseDraft } from "./monthlyExpenseDraft";
import { CloseLayout, visibleColumnsOf } from "./monthlyExpenseLayout";
import { AmountView } from "./monthlyExpenseMath";

interface CloseTableProps extends CloseRowHandlers {
  rows: MonthlyExpenseBranchRow[];
  draft: CloseDraft;
  figures: BranchFigures[];
  layout: CloseLayout;
  expanded: Record<ColumnGroupKey, boolean>;
  view: AmountView;
  isEditable: boolean;
  monthTitle: string;
  estimateTitle: string;
  onToggleGroup: (groupKey: ColumnGroupKey) => void;
}

/** The branch × column sheet: one row per van branch, a sticky header and รวม row. */
export default function CloseTable({
  rows,
  draft,
  figures,
  layout,
  expanded,
  view,
  isEditable,
  monthTitle,
  estimateTitle,
  onToggleGroup,
  ...handlers
}: Readonly<CloseTableProps>) {
  const columns = visibleColumnsOf(layout, expanded);

  return (
    <GridNavigationProvider>
      <TableContainer sx={tableContainerSx(TABLE_MAX_HEIGHT)}>
        <Table size="small" sx={{ ...TABLE_SX, "& td, & th": { whiteSpace: "nowrap" } }}>
          <CloseTableHead
            layout={layout}
            columns={columns}
            expanded={expanded}
            monthTitle={monthTitle}
            estimateTitle={estimateTitle}
            onToggleGroup={onToggleGroup}
          />
          <TableBody>
            {rows.map((row, index) => (
              <CloseTableRow
                key={row.branch_code}
                row={row}
                draft={draft.branches[row.branch_code]}
                figures={figures[index]}
                errors={draft.errors}
                columns={columns}
                rowIndex={index}
                view={view}
                isEditable={isEditable}
                monthTitle={monthTitle}
                estimateTitle={estimateTitle}
                {...handlers}
              />
            ))}
          </TableBody>
          <CloseTableFoot rows={rows} draft={draft} figures={figures} columns={columns} view={view} />
        </Table>
      </TableContainer>
    </GridNavigationProvider>
  );
}
